module.exports = __webpack_public_path__ + "static/cotas-abarcones-sobredimensionados-eebc3fa27b107399c724ae1424ecae4f.pdf";